.wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  font-family: Oxygen, sans-serif;
}

.label {
  margin-right: 4px;
  font-size: 14px;
  font-weight: 700;
  color: #222;
}

/* Removable grey chip — Oxygen bold 13px #333 on #d9d9d9. */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  color: #333;
  background: #d9d9d9;
  border: none;
  border-radius: 3px;
  cursor: pointer;
}

.chip:hover {
  background: #cfcfcf;
}

.remove {
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  color: #555;
}

/* "Clear All" link. */
.clearAll {
  margin-left: 4px;
  padding: 0;
  font-family: inherit;
  font-size: 13px;
  color: #222;
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
}
